<template>
  <b-container>
    <b-row align-h="center">
      <b-col cols="12" md="8" lg="6" class="py-3">
        <p class="lead mb-5">{{ $t('profile:lead-remove-user-account') }}</p>
        <p>
          <b-button variant="danger" @click.self="sendRemovalRequest" :disabled="removalRequest.loading" :class="{ 'loading': removalRequest.loading }" v-if="!removalRequest.done">{{ $t('profile:button-request-user-account-removal') }}</b-button>
          <b-alert :show="removalRequest.done" variant="success">{{ $t('profile:confirmation-remove-user-account') }}</b-alert>
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  data () {
    return {
      removalRequest: {
        loading: false,
        done: false
      }
    }
  },
  methods: {
    sendRemovalRequest () {
      this.removalRequest.loading = true
      const self = this
      return new Promise((resolve, reject) => {
        this.axios.post('/feedback/open', { message: 'User has requested their account to be removed. Please confirm via email.' }).then(response => {
          self.removalRequest.loading = false
          self.removalRequest.done = true
          resolve()
        }).catch(err => {
          self.removalRequest.loading = false
          reject(err)
        })
      })
    }
  }
}
</script>
